import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MS - Orthopedics, Fellowship - Joint Replacement",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Hip Replacement Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, MS - Orthopedics, DNB - Orthopedics",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Minimally Invasive Hip Surgery Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MS - Orthopedics, MCh - Orthopedic Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Robotic Hip Replacement Specialist"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MS - Orthopedics, Fellowship - Arthroplasty",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Anterior Approach Hip Replacement"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MS - Orthopedics, MCh - Joint Replacement",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Revision Hip Surgery Specialist"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, MS - Orthopedics, Fellowship - Adult Reconstruction",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Computer Navigated Hip Surgery"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Hip Replacement Surgery Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert surgical care for hip replacement with advanced techniques for pain-free mobility and improved quality of life.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const HipReplacementSurgery = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced Hip Replacement Surgery
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Total Hip Replacement with 98% Success Rate. Restore Pain-Free Mobility and Active Lifestyle with Precision Surgery.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Emergency Hip Pain Care
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>98%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Surgical Success Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>20+</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Years Implant Longevity</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>1-3</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Days Hospital Stay</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>15+</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Years Expert Team</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "symptoms", label: "Symptoms", icon: "🔍" },
              { id: "types", label: "Types", icon: "🎯" },
              { id: "procedure", label: "Procedure", icon: "🔬" },
              { id: "recovery", label: "Recovery", icon: "⚕️" },
              { id: "implants", label: "Implants", icon: "🦴" },
              { id: "faq", label: "FAQ", icon: "❓" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Hip Replacement Surgery</span>
            </h2>
          </div>

          {/* What is Hip Replacement */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Hip Replacement Surgery
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                Hip replacement surgery, also known as hip arthroplasty, is a surgical procedure in which a 
                damaged hip joint is replaced with an artificial implant. This procedure is typically recommended 
                for patients with severe hip pain and disability caused by conditions like osteoarthritis, 
                rheumatoid arthritis, or hip fractures that haven't responded to conservative treatments.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>When is it Needed?</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Recommended when hip pain significantly limits daily activities like walking, climbing 
                      stairs, and rising from chairs, and when conservative treatments no longer provide 
                      adequate relief from chronic pain.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Success Rates</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Over 98% of hip replacement surgeries are successful, with most patients experiencing 
                      significant pain relief and improved mobility that lasts 20+ years with proper care 
                      and follow-up.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Symptoms & Indications */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Symptoms & Indications for Hip Replacement
            </h3>

            <div className="row">
              {[
                {
                  title: "Severe Hip Pain", 
                  description: "Persistent pain in hip, groin, or thigh that limits everyday activities and affects sleep",
                  details: "Pain continues during rest and nighttime"
                },
                {
                  title: "Stiffness & Limited Mobility", 
                  description: "Difficulty bending, walking, or putting on shoes and socks due to hip stiffness",
                  details: "Reduced range of motion affecting daily functions"
                },
                {
                  title: "Limping & Gait Changes", 
                  description: "Visible limping or walking abnormality due to pain and joint degeneration",
                  details: "May require assistive devices for walking"
                },
                {
                  title: "Failed Conservative Treatment", 
                  description: "No relief from anti-inflammatory medications, physical therapy, or injections",
                  details: "Exhausted all non-surgical options without improvement"
                },
                {
                  title: "Joint Deformity", 
                  description: "Visible changes in hip joint alignment or leg length discrepancy",
                  details: "Advanced arthritis causing structural changes"
                },
                {
                  title: "Quality of Life Impact", 
                  description: "Inability to participate in activities you enjoy due to hip pain and limitation",
                  details: "Affects work, social life, and overall well-being"
                }
              ].map((symptom, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {symptom.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {symptom.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {symptom.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Hip Replacement Types */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Types of Hip Replacement Procedures
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Total Hip Replacement",
                    description: "Complete replacement of both acetabulum (socket) and femoral head (ball) with artificial components",
                    treatment: "Gold standard for advanced arthritis, most common procedure"
                  },
                  {
                    type: "Partial Hip Replacement",
                    description: "Replacement of only the femoral head, preserving natural acetabulum",
                    treatment: "Typically for hip fractures in elderly patients"
                  },
                  {
                    type: "Minimally Invasive Surgery",
                    description: "Smaller incisions with specialized instruments to minimize tissue damage and speed recovery",
                    treatment: "Reduced pain, quicker recovery, less scarring"
                  },
                  {
                    type: "Anterior Approach",
                    description: "Surgery from front of hip, avoiding muscle cutting for faster recovery",
                    treatment: "Muscle-sparing technique, reduced dislocation risk"
                  },
                  {
                    type: "Robotic-Assisted Surgery",
                    description: "Computer navigation and robotic arms for precision bone preparation and optimal implant positioning",
                    treatment: "Enhanced accuracy, customized implant placement"
                  },
                  {
                    type: "Revision Hip Replacement",
                    description: "Replacement of failed previous hip replacement with new components",
                    treatment: "Complex procedure for implant failure, wear, or infection"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Causes & Risk Factors */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Causes & Risk Factors for Hip Arthritis
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Primary Causes</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Osteoarthritis - age-related wear and tear</li>
                      <li style={{ marginBottom: "10px" }}>Rheumatoid arthritis - autoimmune condition</li>
                      <li style={{ marginBottom: "10px" }}>Avascular necrosis - bone death from poor blood supply</li>
                      <li style={{ marginBottom: "10px" }}>Hip fractures and traumatic injuries</li>
                      <li>Congenital hip disorders (developmental dysplasia)</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Risk Factors</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Age over 50 years</li>
                      <li style={{ marginBottom: "10px" }}>Obesity and excess weight</li>
                      <li style={{ marginBottom: "10px" }}>Family history of arthritis</li>
                      <li style={{ marginBottom: "10px" }}>Previous hip injuries or surgeries</li>
                      <li>Certain occupations with heavy physical demands</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Treatment Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Non-Surgical Management
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Conservative treatments that can provide relief for mild to moderate hip arthritis 
                    and may delay or prevent the need for surgical intervention in some cases.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Conservative Treatments:</h6>
                    <div className="row">
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Physical therapy and exercises</li>
                          <li style={{ marginBottom: "8px" }}>Weight management programs</li>
                          <li style={{ marginBottom: "8px" }}>Anti-inflammatory medications</li>
                        </ul>
                      </div>
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Corticosteroid injections</li>
                          <li style={{ marginBottom: "8px" }}>Viscosupplementation (gel injections)</li>
                          <li style={{ marginBottom: "8px" }}>Assistive devices (canes, walkers)</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Limitations:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}>Temporary relief only</li>
                      <li style={{ marginBottom: "8px" }}>Does not stop disease progression</li>
                      <li style={{ marginBottom: "8px" }}>Limited effectiveness in advanced arthritis</li>
                      <li>May delay but not prevent eventual surgery</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Surgical Hip Replacement
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Surgical Procedure:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>General or spinal anesthesia</li>
                      <li style={{ marginBottom: "10px" }}>1-2 hour surgery duration</li>
                      <li style={{ marginBottom: "10px" }}>Damaged bone and cartilage removed</li>
                      <li style={{ marginBottom: "10px" }}>Metal and plastic implants precisely positioned</li>
                      <li>Optimal alignment for natural hip function</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Advanced Techniques:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Computer-assisted navigation</li>
                      <li style={{ marginBottom: "10px" }}>Robotic-arm assisted surgery</li>
                      <li style={{ marginBottom: "10px" }}>Patient-specific instrumentation</li>
                      <li style={{ marginBottom: "10px" }}>Minimally invasive approaches</li>
                      <li>Enhanced recovery protocols</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Implant Options:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Cemented vs cementless fixation</li>
                      <li style={{ marginBottom: "10px" }}>Ceramic or metal femoral heads</li>
                      <li style={{ marginBottom: "10px" }}>Highly cross-linked polyethylene liners</li>
                      <li>Dual mobility constructs for stability</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Surgical Procedure Timeline */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Surgical Procedure & Recovery Timeline
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Day 1-3",
                    title: "Hospital Stay",
                    activities: ["Pain management", "Physical therapy begins", "Walking with assistance", "Incision care"]
                  },
                  {
                    period: "Week 1-2",
                    title: "Early Recovery",
                    activities: ["Home exercises", "Gradual walking improvement", "Wound monitoring", "Pain control"]
                  },
                  {
                    period: "Week 3-6",
                    title: "Rehabilitation",
                    activities: ["Outpatient physical therapy", "Increased mobility", "Driving may resume", "Return to light work"]
                  },
                  {
                    period: "Month 2-3",
                    title: "Advanced Recovery",
                    activities: ["Strength building", "Most activities resume", "Minimal pain", "Follow-up evaluation"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Rehabilitation & Aftercare */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Rehabilitation & Long-term Care
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Physical Therapy</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Begins day of surgery in hospital</li>
                      <li style={{ marginBottom: "10px" }}>Focus on gait training and mobility</li>
                      <li style={{ marginBottom: "10px" }}>Strength and range of motion exercises</li>
                      <li>Continues for 3-6 months post-surgery</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Long-term Care</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Regular follow-up appointments</li>
                      <li style={{ marginBottom: "10px" }}>Maintain healthy weight</li>
                      <li style={{ marginBottom: "10px" }}>Low-impact exercise routine</li>
                      <li>Avoid high-impact activities and extreme positions</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "How long does a hip replacement last?",
                  answer: "Modern hip replacements are designed to last 20 years or more, with many patients enjoying their implants for 25-30 years. The longevity depends on several factors including the patient's age, weight, activity level, and the type of implant used. Advances in materials and surgical techniques have significantly improved implant durability. Highly cross-linked polyethylene liners and improved metal alloys have reduced wear rates. However, younger, more active patients may experience faster wear, while older, less active patients may have implants that last longer. Regular follow-up with your orthopedic surgeon and maintaining a healthy lifestyle can help maximize the lifespan of your hip replacement. If revision surgery becomes necessary, it is typically successful, though more complex than the initial replacement."
                },
                {
                  question: "What is the recovery time after hip replacement surgery?",
                  answer: "Recovery from hip replacement surgery follows a predictable timeline, though individual experiences may vary. Most patients stay in the hospital for 1-3 days after surgery. During the first 2-4 weeks, you'll focus on pain management and basic mobility with a walker or cane. By 6 weeks, many patients can walk without assistive devices and resume light activities. At 3 months, most daily activities can be performed comfortably, and many patients return to work (depending on job demands). Full recovery with maximal strength and endurance typically takes 6-12 months. Physical therapy is crucial throughout this process, starting the day after surgery and continuing for several months. The most significant improvements in pain and function occur in the first 3-6 months, but subtle improvements can continue for up to a year as muscles strengthen and tissues fully heal."
                },
                {
                  question: "Is hip replacement surgery painful?",
                  answer: "While hip replacement is major surgery, modern pain management techniques have made it much more comfortable than in the past. During surgery, you'll be under general or spinal anesthesia and feel no pain. After surgery, a multimodal pain management approach is used, including nerve blocks, epidural catheters, and various medications. Most patients describe the post-operative pain as manageable and significantly less than their pre-surgery arthritis pain. The first 2-3 days are typically the most uncomfortable, but pain decreases rapidly after that. By the time you leave the hospital (usually 1-3 days), most patients require only oral pain medications. Compared to the constant, debilitating pain of advanced arthritis that many patients experience before surgery, the temporary surgical pain is often considered a worthwhile trade-off for long-term pain relief and improved mobility."
                },
                {
                  question: "What activities can I do after hip replacement?",
                  answer: "After fully recovering from hip replacement surgery, most patients can return to a wide range of activities that were previously limited by pain. Recommended activities include walking, swimming, cycling, golf, dancing, and low-impact aerobics. These activities help maintain fitness without putting excessive stress on the implant. However, high-impact activities like running, jumping, and contact sports are generally discouraged as they can accelerate wear on the implant and increase the risk of loosening. Activities that involve heavy lifting or repetitive high stress on the hip should also be avoided. Specific precautions include avoiding crossing legs, bending hips beyond 90 degrees, and twisting motions. Your orthopedic surgeon will provide specific recommendations based on your individual case, the type of implant used, and your overall health."
                },
                {
                  question: "What's the difference between anterior and posterior approach hip replacement?",
                  answer: "The anterior and posterior approaches are two different surgical techniques for hip replacement. The posterior approach is the traditional method where the incision is made on the back of the hip. It provides excellent visualization but requires cutting through some muscles. The anterior approach is a muscle-sparing technique where the incision is made on the front of the hip. This approach avoids cutting major muscles, potentially leading to faster recovery, less pain, and lower dislocation risk. However, it requires specialized training and equipment. Key differences include: Anterior approach - faster initial recovery, less tissue damage; Posterior approach - longer surgical history, excellent visualization; Recovery time may be shorter with anterior approach; Dislocation risk may be lower with anterior approach. The best approach depends on your specific anatomy, the surgeon's expertise, and your individual goals. Your orthopedic surgeon will recommend the most appropriate technique for your situation."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Ready for Pain-Free Mobility?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our expert orthopedic surgeons provide advanced hip replacement for restored mobility and improved quality of life.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Orthopedic Surgery: <strong>080-6541-7705</strong> | Joint Replacement: <strong>080-6541-7715</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default HipReplacementSurgery;